import { DepartmentState, DepartmentActionTypes } from './type';
import { Reducer } from 'redux';


const initialState: DepartmentState = {
  list: [],
  obj: {},
}

const reducer: Reducer<DepartmentState> = (state = initialState, action) => {
  switch (action.type) {
    case DepartmentActionTypes.FETCH_DEPARTMENT_LIST_SUCCESS: {
      const { data } = action;
      return {
        ...state,
        ...data
      }
    }
    default: {
      return state
    }
  }
}

export { reducer as DepartmentReducer };